/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ListConvenienceQueryResponse,
  ListConvenienceQueryParams,
} from '../types/ListConvenience'

function getListConvenienceUrl() {
  const res = { method: 'GET', url: `/api/v1/places/convenience/` as const }
  return res
}

/**
 * @summary List convenience chains
 * {@link /api/v1/places/convenience/}
 */
export async function listConvenience(
  params?: ListConvenienceQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ListConvenienceQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getListConvenienceUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
